var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('acgn-group-edit',{attrs:{"comicId":_vm.comicId,"isEdit":false}}),_c('acgn-statics-staff',{attrs:{"comicId":_vm.comicId,"isShowManage":false,"routeType":4,"title":"项目统计"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }